//@ts-nocheck
import React, { Fragment } from 'react';
import Layout from '../../components/Layout/Layout';
import ActionBtn from '../../components/Button/ActionBtn';
import SecTestimonial from '../../components/Sections/SecTestimonial';
import CardEndOffer from '../../components/CardEndOffer';
import { Col, Container, Row } from 'react-bootstrap';
import OurValues from './component/OurValues';
import Lottie from 'react-lottie';
import animationData from './../../assets/lotties/about.json';
import ai from './../../assets/lotties/ai.json';
import partner from './../../assets/lotties/partner.json';

const AboutUs = () => {
  return (
    <Fragment>
      <Layout title='About Us' description='About Us Desc'>

        {/**
         * SECTION 1: Hero / Intro
         * Updated the links on the ActionBtns below.
         */}
        <section className='pt-16 md:pt-24 lg:pt-32 pb-0 relative overflow-hidden'>
          <img 
            src={"/images/Container.svg"} 
            className='absolute w-full h-full object-cover left-1/2 -translate-x-1/2 top-0 pointer-events-none' 
            alt="" 
          />
          <Container className='relative z-[1] mt-[3rem] px-4 sm:px-6 lg:px-8'>
            <h2 className="font-bold text-4xl sm:text-5xl md:text-6xl mb-4 sm:mb-[2rem] text-black">
              FuteurAI
            </h2>
            <h3 className="font-medium text__46 text-black mb-4 sm:mb-[2rem]">
              Redefining Business Credit for Small Businesses Everywhere
            </h3>
            <Row className='gap-y-8'>
              <Col md={7} className='md:!order-1 order-2'>
                <video
                  src="/about.mp4"
                  className="rounded-[40px] w-full h-auto"
                  autoPlay
                  loop
                  muted
                  playsInline
                />
              </Col>
              <Col md={5} className='order-1 md:!order-2'>
                <p className="text__20 text-Mneutral700 leading-relaxed mb-[2rem]">
                  Where innovation meets opportunity—
                </p>
                <p className="text__20 text-black font-bold leading-relaxed mb-[2rem]">
                  Empowering small businesses to grow with clarity, confidence, and cutting-edge AI solutions.
                </p>
                <p className="text__20 text-black font-bold leading-relaxed mb-[2rem]">
                  Ready to Transform Your Business?
                </p>
                <div className="flex flex-wrap gap-4">
                  {/** Updated Button Links: */}
                  <ActionBtn 
                    link="https://app.futeur.ai/signup" 
                    title="Get Started" 
                  />
                  <ActionBtn 
                    link="/SeeHowItWorks" 
                    title="Learn How It Works" 
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/**
         * SECTION 2: Trusted Partnerships
         
        <section className='py-12 sm:py-16'>
          <Container className='px-4 sm:px-6 lg:px-8'>
            <div className="bg-transparent rounded-[56px]">
              
              <div className="flex flex-wrap xl:flex-nowrap xl:justify-between gap-x-4 gap-y-4">
                <img
                  src="/collab/Experian.png"
                  className="w-[400px] h-[200px] object-contain"
                  alt="Experian Logo"
                />
                <img
                  src="/collab/Equifax.png"
                  className="w-[400px] h-[200px] object-contain"
                  alt="Equifax Logo"
                />
              </div>
            </div>
          </Container>
        </section>
*/}
        {/**
         * SECTION 3: Helping Small Businesses
         */}
        <section className='py-12 sm:py-16'>
          <Container className='px-4 sm:px-6 lg:px-8'>
            <Row className='justify-between'>
              <Col md={6} xl={5}>
                <h3 className='font-medium text__40 text-black'>
                  Helping 34.8 Million Small Businesses Across America Understand, Monitor, 
                  and Improve Their Business Credit.
                </h3>
              </Col>
              <Col md={6} xl={5}>
                <div className="grid grid-rows-1 gap-y-3 mt-6 md:mt-0">
                  {[
                    {
                      title: "Leveling the Playing Field",
                      desc: "Providing small businesses the financial clarity large corporations enjoy.",
                      animation: animationData,
                    },
                    {
                      title: "AI-Powered Platform",
                      desc: "Simplifying credit navigation with ease and confidence for small business owners.",
                      animation: ai,
                    },
                    {
                      title: "Trusted Partnerships",
                      desc: "Real-time insights from Equifax, Experian and more tailored to unique business needs.",
                      animation: partner,
                    },
                  ].map((obj, index) => (
                    <div 
                      key={index} 
                      className="flex items-start gap-4 py-[2rem] border-b border-Mneutral200"
                    >
                      <div className="w-[56px] xl:w-[72px] h-[56px] xl:h-[72px] rounded-[10px] bg-Mneutral100 flex items-center justify-center flex-shrink-0">
                        <Lottie
                          options={{
                            animationData: obj.animation,
                            autoplay: true,
                            loop: true,
                          }}
                          height={56}
                          width={56}
                        />
                      </div>
                      <div>
                        <h5 className='font-medium text__24 mb-2 text-black'>
                          {obj.title}
                        </h5>
                        <p className='text__16 text-black'>
                          {obj.desc}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/**
         * SECTION 4: Experience / Reach / Partnerships Cards
         */}
        <section className='py-12 sm:py-16 bg-gray-50'>
          <Container className='px-4 sm:px-6 lg:px-8'>
            <Row className='gap-y-4'>
              {/** Card 1 */}
              <Col md={6} lg={4}>
                <div className="w-full h-[300px] xl:h-[400px] p-4 rounded-[24px] bg-Mneutral50 flex flex-wrap">
                  <h5 className='font-medium text__24 w-full text-black'>
                    Experience
                  </h5>
                  <div className="self-end">
                    <h3 className='font-medium text__72 mb-2 text-black'>10+ Years</h3>
                    <p className='text__14 text-black'>
                      Building trust and delivering results for more than 10 years.
                    </p>
                  </div>
                </div>
              </Col>
              {/** Card 2 */}
              <Col md={6} lg={4}>
                <div className="w-full h-[300px] xl:h-[400px] p-4 rounded-[24px] bg-Mneutral50 flex flex-wrap">
                  <h5 className='font-medium text__24 w-full text-black'>Reach</h5>
                  <div className="self-end">
                    <h3 className='font-medium text__72 mb-2 text-black'>
                      34.8 M
                    </h3>
                    <p className='text__14 text-black'>
                      Connecting businesses across New York to California, ready to empower growth.
                    </p>
                  </div>
                </div>
              </Col>
              {/** Card 3 */}
              <Col md={6} lg={4}>
                <div className="w-full h-[300px] xl:h-[400px] p-4 rounded-[24px] bg-Mneutral50 flex flex-wrap">
                  <h5 className='font-medium text__24 w-full text-black'>Partnerships</h5>
                  <div className="self-end">
                    <h3 className='font-medium text__72 mb-2 text-black'>
                      Licensed+
                    </h3>
                    <p className='text__14 text-black'>
                      Licensed partnerships with Equifax, Experian, and other top-tier providers
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/**
         * SECTION 5: Our Mission
         */}
        <section className='py-12 sm:py-16'>
          <Container className='px-4 sm:px-6 lg:px-8'>
            <div className="w-full bg-Mneutral100 rounded-[24px] sm:rounded-[56px] p-4 sm:p-8 lg:p-12">
              <Row className='gap-y-4'>
                <Col md={6} className='my-auto'>
                  <img
                    className="rounded-[24px] object-cover w-full h-auto"
                    src="/stocks/mission.jpg"
                    alt="Mission"
                  />
                </Col>
                <Col md={6} className='my-auto'>
                  <h4 className='font-medium text__56 mb-3 text-black'>Our mission</h4>
                  <p className='text__20 leading-relaxed text-Mneutral700 mb-2'>
                    Our mission is simple to make business credit accessible, understandable, and actionable. 
                    By offering AI-driven insights and predictive analytics, we empower small business owners 
                    to make informed financial decisions, avoid costly errors, and unlock their growth potential.
                  </p>
                </Col>
              </Row>
            </div>
          </Container>
        </section>

        {/**
         * SECTION 6: Our Vision
         */}
        <section className='py-12 sm:py-16'>
          <Container className='px-4 sm:px-6 lg:px-8'>
            <div className="w-full bg-Mneutral100 rounded-[24px] sm:rounded-[56px] p-4 sm:p-8 lg:p-12">
              <Row className='gap-y-4'>
                <Col md={6} className='my-auto'>
                  <img
                    className="rounded-[24px] object-cover w-full h-auto"
                    src="/stocks/vision.jpg"
                    alt="Vision"
                  />
                </Col>
                <Col md={6} className='my-auto'>
                  <h4 className='font-medium text__56 mb-3 text-black'>Our Vision</h4>
                  <p className='text__20 leading-relaxed text-Mneutral700 mb-2'>
                    We envision a world where every small business, no matter its size, can access tools to thrive. 
                    With AI on your side, we’re breaking down barriers to financial empowerment.
                  </p>
                </Col>
              </Row>
            </div>
          </Container>
        </section>

        {/**
         * SECTION 7: Our Values
         */}
        <OurValues />

        {/**
         * SECTION 8: Testimonials
         */}
        <SecTestimonial />

        {/**
         * (Optional) If you have a final CTA or End-Offer card, place it here
         * <CardEndOffer />
         */}
      </Layout>
    </Fragment>
  );
};

export default AboutUs;

